import { useEffect, useState } from "react";
import { Download, Share } from "lucide-react";

// Botón "Instalar app" para la PWA del panel.
// - Android/Chrome: usa beforeinstallprompt.
// - iOS/Safari: muestra instrucciones (Compartir → Añadir a pantalla de inicio).
// - Oculto si la app ya está instalada (modo standalone).
export const InstallAppButton = ({ className = "" }) => {
  const [deferred, setDeferred] = useState(null);
  const [isIos, setIsIos] = useState(false);
  const [installed, setInstalled] = useState(false);
  const [showHint, setShowHint] = useState(false);

  useEffect(() => {
    const standalone = window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;
    setInstalled(standalone);
    setIsIos(/iphone|ipad|ipod/i.test(window.navigator.userAgent));
    const onPrompt = (e) => { e.preventDefault(); setDeferred(e); };
    const onInstalled = () => setInstalled(true);
    window.addEventListener("beforeinstallprompt", onPrompt);
    window.addEventListener("appinstalled", onInstalled);
    return () => {
      window.removeEventListener("beforeinstallprompt", onPrompt);
      window.removeEventListener("appinstalled", onInstalled);
    };
  }, []);

  if (installed || (!deferred && !isIos)) return null;

  const install = async () => {
    if (deferred) {
      deferred.prompt();
      const { outcome } = await deferred.userChoice;
      if (outcome === "accepted") setDeferred(null);
    } else {
      setShowHint((s) => !s);
    }
  };

  return (
    <div className={className} data-testid="install-app">
      <button
        type="button"
        onClick={install}
        data-testid="install-app-btn"
        className="w-full inline-flex items-center justify-center gap-2 border border-sand/30 text-sand hover:bg-sand hover:text-jungle font-body py-3 transition-colors"
      >
        {isIos ? <Share size={16} /> : <Download size={16} />}
        Instalar app en este dispositivo
      </button>
      {showHint && isIos && (
        <p data-testid="install-ios-hint" className="font-body text-xs text-sand/70 mt-3 text-center">
          En Safari: toca el botón Compartir y luego «Añadir a pantalla de inicio».
        </p>
      )}
    </div>
  );
};
